import React, {useEffect, useRef, useState} from 'react';
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import Menu from "../../../components/reports/report-menu/menu.jsx";
import AutoDatetime from "../../../components/reports/auto-datetime/auto-datetime.jsx";
import {Card} from "../../../components/card/card.jsx";
import NotAppliedContent from "../../../components/reports/report-menu/not-applied-content.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";
import ReportUtils from "../../../utils/report-utils.js";
import {useGlobalKey} from "../../../hooks/use-global-key.js";
import {format, subMonths} from "date-fns";
import Filters from "./components/filters.jsx";
import Content from "./components/content.jsx";
import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const initialFilters = () => ({
    dtStart: subMonths(new Date(), 2),
    dtEnd: new Date(),
    smartcapture: [],
    searchDetails: false,
});

const filterLabels = {
    date_start: "Data inicial *",
    date_end: "Data final *",
    smartcapture: "SmartCapture",
    searchDetails: "Detalhamento da pesquisa",
};
const SlaCollectionPoint = () => {
    const [loading, setLoading] = useState(false);

    const [collapsed, setCollapsed] = useState(false);
    const buttonRef = useRef(null);
    const [fixedTop, setFixedTop] = useState(null);

    const [filters, setFilters] = useState(initialFilters);
    const [reportData, setReportData] = useState(null);

    const [tableColumns, setTableColumns] = useState(() => ({
        device: {label: "Nome do dispositivo", visible: true},
        pin: {label: "PIN", visible: true},
        sla: {label: "SLA", visible: true},
        inactive: {label: "Inoperante", visible: true},
        events: {label: "Quantidade de eventos", visible: true}
    }));

    const [appliedFilters, setAppliedFilters] = useState(initialFilters);
    const [canExport, setCanExport] = useState(false)
    const [title] = useState("SLA dos smartcaptures");
    const [headerSelected, setHeaderSelected] = useState(-1);

    useEffect(() => {
        if (!reportData) return;

        ReportUtils.appendFilters(
            ReportUtils.filters({
                date_start: filters.dtStart ? format(filters.dtStart, "dd/MM/yyyy") : "",
                date_end: filters.dtEnd ? format(filters.dtEnd, "dd/MM/yyyy") : "",
                ...filters,
            }, filterLabels)
        );

    }, [reportData]);
    const apply = async () => {
        ReportUtils.applyLoad({
            setLoading,
            clearContent: () => {
                setReportData(null)
            }
        });

        try {
            const periodValidation = ReportUtils.validateOnlyDates(filters.dtStart, filters.dtEnd, 2, "months");

            if (!periodValidation.ok) {
                ReportUtils.alertErrorMessage(periodValidation.message);
                setLoading(false);
                return;
            }

            const formattedFilters = {
                date_start: filters.dtStart ? format(filters.dtStart, "dd/MM/yyyy") : null,
                date_end: filters.dtEnd ? format(filters.dtEnd, "dd/MM/yyyy") : null,
                smartcapture: filters.smartcapture?.map(i => i.value) ?? [],
            };

            const auditFilters = ReportUtils.filters({
                    ...filters,
                    searchDetails: filters.searchDetails ? "Sim" : "Não",
                    date_start: formattedFilters.date_start,
                    date_end: formattedFilters.dt_end},
                filterLabels, true);

            const { data: response } = await axios.post(API_URL + "/sla_collection_point/apply", {
                ...formattedFilters,
                filters: auditFilters
            });

            const data = response.data;
            setReportData(data);
            setAppliedFilters(filters);
            setCanExport(!filters.searchDetails)

            const scale = window.visualViewport?.scale ?? 1;
            if (window.innerWidth <= 1440 || scale > 1) setCollapsed(true);

        } catch (error) {

            let {message} = error.response.data;

            ReportUtils.alertErrorMessage(message ?? "Erro ao gerar o relatório.");
            console.error("Erro ao gerar o relatório", error);

        } finally {
            setLoading(false);
        }
    };
    useGlobalKey("Enter", apply);

    const clearSearch = () => {
        setFilters(initialFilters);
        setReportData(null);
    }

    const toggleFilters = () => {
        if (!collapsed && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setFixedTop(rect.top);
        }

        setCollapsed(prev => !prev);
    }

    const printComponentRef = useRef(null);
    return (
        <div className={"flex"}>

            <Template isLoading={loading}>
                <Template.Header>
                    <div className="flex justify-between w-full">
                        <Template.Title>{title}</Template.Title>
                        <HeaderButtons
                            exportable={canExport}
                            exportInSheets={canExport}
                            printable={true}
                            headerChange={true}
                            visibilityColumns={true}
                            columns={tableColumns}
                            setColumns={setTableColumns}
                            printComponentRef={printComponentRef}
                            reportData={reportData}
                            data={reportData?.length}
                            headerSelected={headerSelected}
                            setHeaderSelected={setHeaderSelected}
                        />
                    </div>
                </Template.Header>
                <Template.Body className={`${collapsed ? 'p-[0]' : ''}`}>
                    <Menu buttonRef={buttonRef} toggleFilters={toggleFilters} fixedTop={fixedTop}
                          collapsed={collapsed} apply={apply} clearSearch={clearSearch}>

                        <Filters setFilters={setFilters} filters={filters}/>
                        <AutoDatetime setFilters={setFilters}/>

                    </Menu>
                </Template.Body>
            </Template>

            <Card className={`w-full h-fit mr-2 ${!reportData || reportData?.length === 0 ? 'mt-[59px]' : 'mt-[61px]' } print:!mt-[-15px] transform ${!reportData || reportData?.length === 0 ? '!bg-[#f3f3f4] !border-none !-translate-y-[5px]' : ''} ${collapsed ? 'ml-2' : ''}`}>
                <Card.Body>
                    <div className={`flex-1 ${!reportData || reportData?.length === 0 ? 'p-[0]' : 'px-[20px] py-[5px]'}`}>
                        <NotAppliedContent reportData={reportData}/>
                        <NoDataContent reportData={reportData} data={reportData?.length}/>
                        <Content reportData={reportData} data={reportData?.length} entity={headerSelected} title={title} collapsed={collapsed} searchDetails={appliedFilters.searchDetails} setLoading={setLoading} printComponentRef={printComponentRef} tableColumns={tableColumns}/>
                    </div>
                </Card.Body>
            </Card>

        </div>
    );
};

export default SlaCollectionPoint;